import { Divider } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
  (theme) => ({
    finalizeOrdersRowActionDivider: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }),
  { name: 'FinalizeOrdersActionDivider' },
)

export const FinalizeOrdersActionDivider = () => {
  const classes = useStyles()
  return <Divider className={classes.finalizeOrdersRowActionDivider} />
}
